import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  patchRequest,
} from "./AxiosClient";
import Cookies from "js-cookie";
import axios from "axios";

export async function getToken() {
  const token = await Cookies.get("userToken");
  return token;
}

export async function userLogin(email, password) {
  const response = await postRequest("userLogin", {
    email: email,
    password: password,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function userEmailLogin(email, password) {
  const response = await postRequest("v3/makeLogin/email", {
    email: email,
    password: password,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function userMobileLogin(mobile, otp, hash) {
  const response = await postRequest("v3/makeLogin/mobile", {
    mobile: mobile,
    otp: otp,
    hash: hash,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function socialLogin(type, id, email) {
  const response = await postRequest("socialLoginV2", {
    type: type,
    id: id,
    email: email,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getUser() {
  const response = await getRequest("getUser")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getEmailExists(email) {
  const response = await getRequest(`getEmailExists/${email}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function checkLogin(emailOrPhone) {
  const response = await getRequest(`v3/checklogin/${emailOrPhone}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function registerUser(data) {
  const response = await postRequest("userRegistration", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function registerUserV2(data) {
  const response = await postRequest("userRegistrationV2", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function registerUserV3(data) {
  const response = await postRequest("userRegistrationV3", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// V3 registration
export async function newRegisterUserV3(data) {
  const response = await postRequest("v3/registration", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function createUserProgram(data) {
  const response = await postRequest("createMyProgram", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function sendEmailOtp(email) {
  const response = await postRequest("sendEmailOTP", {
    email: email,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function sendMobileOtp(mobile) {
  const response = await postRequest(`v3/mobileOTP/send/${mobile}`, {
    mobile: mobile,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function verifyMobileOtp(mobile, hash, otp) {
  const response = await postRequest(`v3/mobileOTP/verify/${mobile}/${otp}`, {
    hash: hash,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function verifyEmailOtp(email, otp, hash) {
  const response = await postRequest("verifyEmailOtp", {
    email: email,
    otp: otp,
    hash: hash,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getExercises() {
  const response = await getRequest("getExercises")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getExercisesById(exerciseId) {
  const response = await getRequest(`getExercises/${exerciseId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getCoins() {
  const response = await getRequest("getCoins")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function updateUserProfile(data) {
  const response = await putRequest("editProfile", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function updateAvatar(data) {
  const response = await putRequest("editProfileAvatar", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function updateCover(data) {
  const response = await putRequest("editProfileCover", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getExercisePerformanceGraph() {
  const response = await getRequest("getExercisePerformanceGraph")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getLeaderboard() {
  const response = await getRequest("getLeaderboard")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Performance/v3 -  Exercise Count Graph
export async function getExerciseCountGraph(range = "week") {
  const response = await getRequest(`v3/getExerciseCountGraph/${range}`)
    .then((response) => {
      // console.log("calling from api : " + response.data);
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Performance/v3 -  Calories Burnt Graph
export async function getCaloriesGraph(range = "week") {
  const response = await getRequest(`v3/getCaloriesBurntGraph/${range}`)
    .then((response) => {
      // console.log("calories " + response.data);
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    });
  // console.log(response);
  return response.data;
}

// Performance/v3 -  Performed Time Graph
export async function getMinutesGraph(range = "week") {
  const response = await getRequest(`v3/getTimeSpentGraph/${range}`)
    .then((response) => {
      // console.log("Time Graph " + response.data);
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getExerciseAccuracyGraph(range = "week") {
  const response = await getRequest(`getExerciseAccuracyGraph/${range}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getFrequencyGraph() {
  const response = await getRequest("getFrequencyGraph")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// V3/PROFILE
export async function getProfile() {
  const response = await getRequest("v3/getProfile")
    .then((response) => {
      // console.log("getUserProfile" + response);
      // console.log("User Streaks :" + response.streak);
      // console.log("Exercises Done by User :" + response.exe_done);
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function getV3Programs(day, injuries) {
  const response = await postRequest(
    "v3/createHyperProgramOfTheDay/" + day + "/" + injuries
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getUserActivities() {
  const response = await getRequest("getUserActivities")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getUserPlaylist() {
  const response = await getRequest("getUserPlaylist")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getModules() {
  const response = await getRequest("getModules")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getAllModules() {
  const response = await getRequest("getAllModules")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function createUserPlaylist(playlistName) {
  const response = await postRequest("createUserPlaylist", {
    pname: playlistName,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function addExercisesToPlaylist(playlistId, exerciseId) {
  const response = await postRequest("addExercisesToPlaylist", {
    pid: playlistId,
    eid: exerciseId,
  }).then((response) => {
    return response;
  });
  return response.data;
}

export async function addMultipleExercisesToPlaylist(
  playlistId,
  exerciseIdList
) {
  const response = await postRequest("addMutliExeToPlaylist", {
    pid: playlistId,
    exercises: exerciseIdList,
  }).then((response) => {
    return response;
  });
  return response.data;
}

export async function getMyRank() {
  const response = await getRequest("getMyRank").then((response) => {
    return response;
  });
  return response.data;
}

export async function getBmi(data) {
  const response = await postRequest("getBMI", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function resetPassword(email, password) {
  const response = await patchRequest("resetPassword", {
    email: email,
    new_password: password,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function changePassword(oldPassowrd, newPassword) {
  const response = await patchRequest("changePassword", {
    old_password: oldPassowrd,
    new_password: newPassword,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getStartedExercise(oldPassowrd, newPassword) {
  const response = await getRequest("getStartedExercises")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getResult(resultId) {
  const response = await getRequest(`getResult/${resultId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getTrailResult(resultId) {
  const response = await getRequest(`getTrailResult/${resultId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}
// export async function getCouponDetails(coupon) {
//   const response = await getRequest(`v3/getCouponDetails/${coupon}`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error.response;
//     });
//   return response.data;
// }

export async function getCouponDetails(coupon) {
  const response = await getRequest(`v3/getCouponDetails/${coupon}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// v3/Exercise-Card - Programs Exercise Card
export async function getAllSemiPrograms() {
  const response = await getRequest(`v3/getAllSemiPrograms/`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// V3/Hyper-Customize - Card
export async function getMyHyperProgramAPI() {
  const response = await getRequest(`v3/getMyHyperProgram`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getPlaylistDetails(playlistId) {
  const response = await getRequest(`getInhousePlaylistInfo/${playlistId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response;
    
}

export async function getUserPlaylistDetails(playlistId) {
  const response = await getRequest(`getPlaylistInfo/${playlistId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function addOtherUserPlaylist(playlistId) {
  const response = await postRequest(`installUserPlaylist`, {
    playlistId: playlistId,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function reachUs(email, message) {
  const response = await postRequest("postReachUs", {
    email: email,
    message: message,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function callMe(phone, type) {
  const response = await postRequest("postCallMe", { phone: phone, type: type })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function updateNotificationToken(token) {
  const response = await postRequest("updateNotificationToken", {
    token: token,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getRazorpayOrder(price) {
  const response = await getRequest(`razorpay/createOrder/${price}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getRazorpaySubscription(plan) {
  const response = await getRequest(`razorpay/sub/${plan}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response?.data;
}

export async function createRazorPayTransaction(data) {
  const response = await postRequest("createTransaction", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getMySubscription() {
  const response = await getRequest("v3/getMySubscription")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function deleteUserPlaylist(playlistId) {
  const response = await postRequest("deleteUserPlaylist", {
    pid: playlistId,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function deleteUserPlaylistExercise(playlistId, exerciseId) {
  const response = await postRequest("deleteExeFromPlaylist", {
    pid: playlistId,
    eid: exerciseId,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getMyProgram() {
  const response = await getRequest("getMyProgram")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getMyProgramV2() {
  const response = await getRequest("getMyProgram/v2")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getMainProgramDetails(programId) {
  const response = await getRequest(`getMyProgram/details/${programId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getStandaloneExercise() {
  const response = await getRequest("getStandalone")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function updateQuestions(data) {
  const response = await postRequest("postQuestion", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getProgramResults() {
  const response = await getRequest("getProgramResult")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getProgramDetails(day) {
  const response = await getRequest(`getMyProgram/day/${day}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getUserSettings() {
  const response = await getRequest(`getUserSettings`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function setUserSettings(settings) {
  const response = await putRequest(`updateSettings`, settings)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function postTrailFeedback({ rating, feedback, workout }) {
  const response = await postRequest("postTrailFeedback", {
    rating: rating,
    feedback: feedback,
    workout: workout,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}
export async function markRestDayAsComplete({ programId, day }) {
  const response = await postRequest("v3/makeRestDayComplete", {
    programId: programId,
    day: day,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getIpDetials() {
  const response = await axios({
    method: "get",
    url: "https://ipapi.co/json/",
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// CREATE-HYPER-PROGRAM for last step of Onboarding page
export async function createHyperProgram(data) {
  const response = await postRequest("v3/createHyperProgram", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// CREATE HYPER PROGRAM OF THE DAY
export async function createHyperProgramOfTheDay(day = "dayNumber") {
  const response = await postRequest(`v3/createHyperProgramOfTheDay/${day}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Puma Challenges API
export async function getPumaChallenges() {
  const response = await getRequest("v3/getChallenges")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    });
  return response.data;
}

// PUMA Get SQUAD
export async function getPumaSquad() {
  const response = await getRequest("v3/getPumaSquads")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    });
  return response.data;
}

// PUMA POST SQUAD
export async function updatePumaUserSquad(data) {
  const response = await postRequest(`v3/updatePumaUserSquad`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Get Puma Leaderboard
export async function getPumaUserLeaderboard(exe) {
  const response = await getRequest(`v3/getPumaLeaderBoard/${exe}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Post Fitness Age
export async function postFitnessAge(userData) {
  const response = await postRequest(`v3/createNewFitnessAgeUser`, userData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Get Fitness Age
export async function getFitnessAge(id) {
  const response = await getRequest(`v3/getFitnessAgeOfUser/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

export async function getCardioHealth(id) {
  const response = await getRequest(`v3/getCardioHealthOfUser/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Top Routines & Top Exercises in ProgramPage
export async function getTopWorkout() {
  const response = await getRequest("v3/getAllWorkout")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    });
  return response.data;
}

// Create Lead from Fitness Test Details
export async function postCreateLead(userData) {
  const response = await postRequest(`v3/createLead`, userData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Fit-A-Thon
export async function FitAThonRegister(data) {
  const response = await postRequest("v3/fitathon", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Call-A-Coach getRequest
export async function getCallACoach() {
  const response = await getRequest("v3/getCoaches")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Call-A-Coach postRequest
export async function postCallACoach(userData) {
  const response = await postRequest(`v3/getCallBack`, userData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Recommended Workout Module
export async function getRecommendedModule() {
  const response = await getRequest("v3/recommendedModules")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}

// Call-A-Coach postRequest
export async function postWorkoutSchedule(userData) {
  const response = await postRequest(`v3/postWorkoutSchedule`, userData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return response.data;
}
